import { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';

import Calories from './calories.js';
import PersianNumberInput from './NumberInput.jsx';
import { useNavigate } from 'react-router-dom';

const Calculator = () => {
  const [age, setAge] = useState(null);
  const [gender, setGender] = useState(null);
  const [weight, setWeight] = useState(null);
  const [height, setHeight] = useState(null);
  const [activityLevel, setActivityLevel] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const [maintainWeightCalories, setMaintainWeightCalories] = useState(null);
  const [mildWeightLossCalories, setMildWeightLossCalories] = useState(null);
  const [bulkWeightCalories, setBulkWeightCalories] = useState(null);
  const [weightLossCalories, setWeightLossCalories] = useState(null);
  const [extremeWeightLossCalories, setExtremeWeightLossCalories] =
    useState(null);
  const navigate = useNavigate();
  const handleClick = (e) => {};
  const calculateCalories = () => {
    let bmr;
    if (gender === 'male') {
      bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    } else {
      bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    }
    return bmr * activityLevel;
  };

  const handleInput = (event) => {
    switch (event.target.name) {
      case 'age':
        setAge(event.target.value);
        break;
      case 'weight':
        setWeight(event.target.value);
        break;
      case 'height':
        setHeight(event.target.value);
        break;
      case 'gender':
        setGender(event.target.value);
        break;
      case 'activity':
        setActivityLevel(event.target.value);
        break;
      default:
        break;
    }
  };

  const [macros, setMacros] = useState();

  const handleSubmitUserInfo = (event) => {
    event.preventDefault();
    if (age && weight && height && gender && activityLevel) {
      setIsEnabled(true);
      const maintainCalories = calculateCalories();
      setMaintainWeightCalories(maintainCalories);
      setMildWeightLossCalories(maintainCalories * 0.89);
      setWeightLossCalories(maintainCalories * 0.81);
      setExtremeWeightLossCalories(maintainCalories * 0.6);
      setBulkWeightCalories(maintainCalories * 1.1);
    } else {
      alert('لطفا تمامی فیلدها را پر کنید');
    }
  };

  const inputStyle =
    'mt-2 block w-full rounded-md border-0 py-1.5 text-main shadow-sm ring-1 ring-inset ring-main placeholder:text-main focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6';
  const selectStyle =
    'mt-2 block w-full rounded-md border-0 bg-white py-1.5 text-main shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6';
  const lableStyle = 'block text-sm font-medium leading-6 text-main';
  const divStyle = 'col-span-6 sm:col-span-3 lg:col-span-3';
  const buttonStyle =
    'bg-main hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded mb-10';
  const buttonDisableStyle =
    'bg-gray-500 text-gray-300 py-2 px-4 border border-blue-700 rounded mb-10';

  const activeButtonStyle = 'bg-blue-500 text-white border-blue-500';
  const inactiveButtonStyle =
    'bg-white text-main border-gray-300 hover:bg-gray-100';

  const baseButtonStyle =
    'px-4 py-2 border rounded font-medium text-main transition-colors duration-150';

  return (
    <div className="mt-10 sm:mt-0">
      <Helmet
        title="محاسبه‌گر کالری مورد نیاز"
        meta={[{ name: 'description', content: 'محاسبه‌گر کالری مورد نیاز' }]}
      />
      <div className="md:grid md:grid-cols-2 md:gap-6 Custom-1">
        <div className="mx-auto">
          <div className="px-4 sm:px-0 text-center">
            <h3 className="text-base font-bold leading-6 text-main mt-20">
              محاسبه‌گر کالری مورد نیاز
            </h3>
            <p className="mt-1 text-sm text-main">
              لطفا تمامی فیلدها را پر کنید
            </p>
          </div>
        </div>
        <div className="mt-5 md:col-span-2 md:mt-0 lg:w-1/2 m-auto">
          <form onSubmit={handleSubmitUserInfo}>
            <div className="overflow-hidden shadow sm:rounded-md ">
              <div className="bg-white px-4 py-5 sm:p-6">
                <div className="grid grid-cols-2 gap-6">
                  {/* Age */}
                  <div className={divStyle}>
                    <label className={lableStyle}>سن</label>
                    <PersianNumberInput
                      value={age || ''}
                      onChange={(val) => setAge(Number(val))}
                      className={inputStyle}
                    />
                  </div>
                  {/* Weight */}
                  <div className={divStyle}>
                    <label className={lableStyle}>وزن</label>
                    <PersianNumberInput
                      value={weight || ''}
                      onChange={(val) => setWeight(Number(val))}
                      className={inputStyle}
                    />
                  </div>
                  {/* Height */}
                  <div className={divStyle}>
                    <label className={lableStyle}>قد</label>
                    <PersianNumberInput
                      value={height || ''}
                      onChange={(val) => setHeight(Number(val))}
                      className={inputStyle}
                    />
                  </div>
                  {/* Gender */}
                  <div className={divStyle}>
                    <label className={lableStyle}>جنسیت</label>
                    <div className="flex gap-2">
                      {['female', 'male'].map((g) => (
                        <button
                          key={g}
                          type="button"
                          className={`${baseButtonStyle} ${
                            gender === g
                              ? activeButtonStyle
                              : inactiveButtonStyle
                          }`}
                          onClick={() =>
                            handleInput({
                              target: { name: 'gender', value: g },
                            })
                          }>
                          {g === 'female' ? 'خانم' : 'آقا'}
                        </button>
                      ))}
                    </div>
                  </div>
                  {/* Activity */}
                  <div className={divStyle}>
                    <label className={lableStyle}>میزان فعالیت</label>
                    <div className="flex flex-col gap-2">
                      {[
                        { label: 'بدون فعالیت', value: '1' },
                        {
                          label: 'کم تحرک: تحرک کم یا بدون تحرک',
                          value: '1.2',
                        },
                        {
                          label: 'سبک: ورزش سبک ۱-۳ بار در هفته',
                          value: '1.375',
                        },
                        {
                          label: 'متوسط: ورزش متوسط ۴-۵ بار در هفته',
                          value: '1.465',
                        },
                        {
                          label: 'فعال: ورزش با شدت بالا ۳-۴ بار در هفته',
                          value: '1.55',
                        },
                        {
                          label: 'بسیار فعال: ورزش با شدت بالا ۶-۷ بار در هفته',
                          value: '1.725',
                        },
                        {
                          label:
                            'فوق العاده فعال: ورزش با شدت بالا دو بار در روز',
                          value: '1.9',
                        },
                      ].map((option) => (
                        <button
                          key={option.value}
                          type="button"
                          className={`${baseButtonStyle} ${
                            activityLevel === option.value
                              ? activeButtonStyle
                              : inactiveButtonStyle
                          }`}
                          onClick={() =>
                            handleInput({
                              target: { name: 'activity', value: option.value },
                            })
                          }>
                          {option.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit button */}
              <div className="px-4 py-3 text-right sm:px-6 text-white">
                <button
                  className="btn bg-fitlinez text-white font-bold px-4 border border-blue-700 rounded w-full"
                  type="submit">
                  محاسبه و دریافت نتیجه
                </button>
              </div>

              {/* Result */}
              {isEnabled && (
                <div className="overflow-x-auto" dir="rtl">
                  <Calories
                    mildWeightLossCalories={mildWeightLossCalories}
                    weightLossCalories={weightLossCalories}
                    extremeWeightLossCalories={extremeWeightLossCalories}
                    maintainWeightCalories={maintainWeightCalories}
                    bulkWeightCalories={bulkWeightCalories}
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
